import { Feature, PlanInterval } from '../models';
import { getCycleFromPathParam, getQuotaFromPathParam } from '../utils/utils';

export type FeatureQuotaAndCycle = {
  quota: number;
  cycle?: PlanInterval;
};

export type FeatureQuotaAndCycleMap = Partial<Record<Feature, FeatureQuotaAndCycle>>;

export const useGetQuotaAndCycleFromPathParams = (
  features: Feature[],
): FeatureQuotaAndCycleMap => {
  const featureQuotaAndCycleMap: FeatureQuotaAndCycleMap = {};

  features.forEach(feature => {
    featureQuotaAndCycleMap[feature] = {
      quota: getQuotaFromPathParam(feature) ?? 0,
      cycle: getCycleFromPathParam(feature),
    };
  });

  return featureQuotaAndCycleMap;
};
